let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8pneL")).then(() => parcelRequire('1BOdm'));